/* Version: 3.5.155 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import { safeRest } from '../../utils/functions.js';
import safeCustomStyle from '../../utils/safeCustomStyle.js';
import { ACCORDION_VARIANT } from './constants.js';
import HeaderIcon from './HeaderIcon.js';
import { HeaderButton, IconWrapper, HeaderTitle } from './styledComponents.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useTheme from '../../hooks/useTheme.js';

var _excluded = ["id", "isExpanded", "title", "titleAs", "ariaLabel", "customStyle", "variant", "ariaControls", "expandIcon", "collapseIcon"];
var Header = function Header(_ref) {
  var id = _ref.id,
    _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === undefined ? false : _ref$isExpanded,
    _ref$title = _ref.title,
    title = _ref$title === undefined ? '' : _ref$title,
    titleAs = _ref.titleAs,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === undefined ? '' : _ref$ariaLabel,
    _ref$customStyle = _ref.customStyle,
    customStyle = _ref$customStyle === undefined ? {
      headerWrapperStyle: {},
      titleStyle: {}
    } : _ref$customStyle,
    _ref$variant = _ref.variant,
    variant = _ref$variant === undefined ? ACCORDION_VARIANT.PRIMARY : _ref$variant,
    ariaControls = _ref.ariaControls,
    expandIcon = _ref.expandIcon,
    collapseIcon = _ref.collapseIcon,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var _safeCustomStyle = safeCustomStyle(customStyle),
    headerWrapperStyle = _safeCustomStyle.headerWrapperStyle,
    titleStyle = _safeCustomStyle.titleStyle;
  var safeProps = safeRest(rest);
  return /*#__PURE__*/jsxs(HeaderButton, _objectSpread(_objectSpread({}, safeProps), {}, {
    type: "button",
    id: id,
    "aria-label": ariaLabel,
    "aria-expanded": isExpanded,
    "aria-controls": ariaControls,
    headerWrapperStyle: headerWrapperStyle,
    theme: theme,
    children: [/*#__PURE__*/jsx(IconWrapper, {
      variant: variant,
      children: /*#__PURE__*/jsx(HeaderIcon, {
        isExpanded: isExpanded,
        expandIcon: expandIcon,
        collapseIcon: collapseIcon,
        variant: variant
      })
    }), /*#__PURE__*/jsx(HeaderTitle, {
      as: titleAs,
      variant: variant,
      titleStyle: titleStyle,
      "data-testid": "".concat(id, "-title"),
      children: title
    })]
  }));
};
process.env.NODE_ENV !== "production" ? Header.propTypes = {
  /** id for header wrapper */
  id: PropTypes.string,
  /** title label for header */
  title: PropTypes.node,
  /** Aria-Label */
  ariaLabel: PropTypes.string,
  /** idREF for aria-controls attribute */
  ariaControls: PropTypes.string,
  /** current state of expansion panel */
  isExpanded: PropTypes.bool,
  /** Icon component to pass for collapsed state */
  expandIcon: PropTypes.node,
  /** Icon component to pass for expanded state */
  collapseIcon: PropTypes.node,
  /** Which style of accordion to use */
  variant: PropTypes.oneOf([ACCORDION_VARIANT.PRIMARY, ACCORDION_VARIANT.SECONDARY, ACCORDION_VARIANT.LEGAL]),
  /** style overrides for header */
  customStyle: PropTypes.shape({
    headerWrapperStyle: PropTypes.object,
    titleStyle: PropTypes.object
  })
} : undefined;
process.env.NODE_ENV !== "production" ? Header.displayName = 'Header' : undefined;

export { Header as default };
